export interface IQuestionFeedback {
  questionId?: number;
  feedBack?: string;
}

export interface IMeetingFeedback {
  questionIds?: number[];
  mentorId?: string;
  meetingId?: number;
  feedBacks?: IQuestionFeedback[];
}

export interface IFeedbackQuestion {
  id: number;
  question: string;
}

export interface IFeedbackItem {
  mentorId: string;
  questionId: number;
  question: string;
  feedBack: string;
}

export const defaultFeedbackEntity: Readonly<IMeetingFeedback> = {
  questionIds: [],
  mentorId: '',
  meetingId: undefined,
  feedBacks: [],
};

export interface IFeedbackQuestionsResponse {
  meetingId: number;
  meetingTitle: string;
  questions: {
    questionId: number;
    question: string;
    isShareFeedBack: boolean;
    feedBack: string;
  }[];
}

export interface FeedbackState {
  loading: boolean;
  updating: boolean;

  errorMessage: string | null;
  questions: IFeedbackQuestion[];
  questionsResponse: IFeedbackQuestionsResponse | null;
  feedbackList: IFeedbackItem[];
  entity: IMeetingFeedback;

  updateSuccess: boolean;
  alreadySubmitted: boolean;
}
